import {useMemo} from 'react';
import {EnrichedAstNode} from 'rendition-core';

export const useCheckIfSomeSelectedNodeAbsolutePositioned = (selectedNodes: EnrichedAstNode[]) => {
    const hasAbsPositionedNode = useMemo(
        () => selectedNodes.some((node) => node.calculatedLayoutAbstraction.absolutePosition === true),
        [selectedNodes]
    );

    return hasAbsPositionedNode;
};
